import {RoleModuleServiceInterface, RoleModuleStoreInterface} from "../../types";
import {RoleAccessRequest, RoleEditRequest, RoleTranslationRequest, RoleViewRequest} from "../../types/request";
import FilterStore from "../abstract.filter.store";
import {action, makeObservable, observable, runInAction} from "mobx";
import {Role} from "../../types/modules";
import {ActionEnum, ResponseTypeEnum} from "../../types/enums";
import {UserPrepareEditFormRequest} from "../../types/modules/user/request";
import {AppStore} from "../app.store";
import {ApiResponseHandler} from "../../handler/apiResponse.handler";

export default class RoleStore extends FilterStore implements RoleModuleStoreInterface {
    public _items: Role[] = [];
    public readonly _module: string = 'role';

    public readonly _headers: string[] = [
        'name', 'id', 'level', 'description'
    ];

    public readonly _actions: ActionEnum[] = [
        ActionEnum.VIEW, ActionEnum.EDIT, ActionEnum.TRANSLATE, ActionEnum.ACCESSES
    ]

    constructor(
        private readonly appStore: AppStore,
        private readonly service: RoleModuleServiceInterface
    ) {
        super();

        makeObservable(this, {
            _current: observable,
            _pageSize: observable,
            _orderFieldName: observable,
            _orderDirection: observable,
            _headers: observable,
            _items: observable,
            _loading: observable,
            setTablePaginationData: action,
            setTableFilterData: action,
        });
    }

    setTablePaginationData = ({ current, pageSize, field, order }: any) => {
        this.current = current;
        this.pageSize = pageSize;
        this.orderFieldName = field;
        this.orderDirection = order;
    }

    public list = () => {
        runInAction(() => {
            this.loading = true;
        })

        return this.service.list({
            ...this.searchFields,
            ...this.paginatorRequestParams,
            checkRoutes: this.accessCheckRequestParams
        })
            .then(({data}) => {
                runInAction(() => {
                    this.items = data.data;
                    this.total = data.totalCount;
                    this.loading = false;
                })
            });
    }

    public edit = (request: RoleEditRequest) => {
        this.appStore.setLoading(true);
        return this.service.edit(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('global.message.role_edit_success', ResponseTypeEnum.SUCCESS)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public view = (request: RoleViewRequest) => {
        return this.service.view(request)
            .then(({data}) => {
                return data;
            });
    }

    public accesses = (request: RoleAccessRequest) => {
        return this.service.accesses(request)
            .then(({data}) => {
                return data;
            });
    }

    public editAccesses = (request: RoleAccessRequest) => {
        this.appStore.setLoading(true);
        return this.service.editAccesses(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('global.message.role_access_edit_success', ResponseTypeEnum.SUCCESS)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public translations = (request: RoleTranslationRequest) => {
        return this.service.translations(request)
            .then(({data}) => {
                return data;
            });
    }

    public editTranslations = (request: RoleTranslationRequest) => {
        this.appStore.setLoading(true);
        return this.service.editTranslations(request)
            .then(({data}) => {
                this.appStore.setResponseMessage('global.message.role_translation_edit_successful', ResponseTypeEnum.SUCCESS)
                return data;
            }).finally(() => {
                    this.appStore.setLoading(false);
                });
    }

    public prepareEditForm = (request: UserPrepareEditFormRequest) => {
        return this.service.prepareEditForm(request)
            .then(({data}) => {
                return data;
            });
    }
}